export default __webpack_public_path__ + "static/4-614bd26057c3c9dfc68dc61ffea19417.svg";